// @flow

import React from 'react';
import $ from 'jquery';
import './animated-element.scss';

type Props = {
  children: React.ReactNode,
  showOn: boolean,
};

const ANIMATION_DURATION_MS = 400; // Also change the timing in .scss after changing this.
const ANIMATION_ADJUSTMENT_DELAY = 10;
let elementNum = 0;

export default class AnimatedDisplayElement extends React.Component {
  props: Props

  constructor() {
    super();
    this.showingElement = null;
    elementNum += 1;
    this.elementNum = elementNum;
    this.elementHeight = 0;
    this.state = {
      showingElement: null,
      recalculateHeight: false,
    };
    this.hideElement = this.hideElement.bind(this);
    this.timeout = null;
    this.recalculatingHeight = false;
    this.updatedNumber = 0;
  }

  componentDidMount() {
    this.$el = $(this.el);
    this.elementHeight = this.$el.height();
    this.animateElement(false);
  }

  componentDidUpdate(prevProps) {
    const { recalculateHeight } = this.state;
    const { showOn: prevShowOn } = prevProps;
    const { showOn } = this.props;
    if (!this.recalculatingHeight && !recalculateHeight && showOn !== prevShowOn) {
      this.recalculatingHeight = true;
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        recalculateHeight: true,
      });
    } else if (this.recalculatingHeight && recalculateHeight) {
      this.$el = $(this.el);
      this.elementHeight = this.$el.height();
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        recalculateHeight: false,
      });
    } else if (this.recalculatingHeight && !recalculateHeight) {
      this.recalculatingHeight = false;
      this.animateElement(true);
    } else {
      this.animateElement(true);
    }
  }

  getElementReference(el) {
    this.el = el;
  }

  getHeight() {
    const { elementHeight, recalculateHeight } = this.state;
    if (recalculateHeight) {
      return 'auto';
    }
    return elementHeight;
  }

  showElement(elementHeight) {
    this.setState({ showingElement: true });
    this.delayedHeightAdjustment(elementHeight);
  }

  hideElement() {
    this.setState({ showingElement: false });
  }

  delayedHeightAdjustment(elementHeight) {
    setTimeout(() => {
      this.setState({ elementHeight });
    }, 10);
  }

  elementShouldBeDisplayed() {
    const { showingElement, recalculateHeight } = this.state;
    const { showOn } = this.props;
    return recalculateHeight || showOn || showingElement;
  }

  animateElement(animate) {
    const { showOn } = this.props;
    clearTimeout(this.timeout);
    if (showOn && this.showingElement !== true) {
      this.showingElement = true;
      this.showElement(this.elementHeight);
    } else if (!showOn && this.showingElement !== false) {
      this.showingElement = false;
      this.delayedHeightAdjustment(0);
      if (animate) {
        setTimeout(this.hideElement, ANIMATION_DURATION_MS + ANIMATION_ADJUSTMENT_DELAY);
      } else {
        this.hideElement();
      }
    }
  }

  render() {
    const { children } = this.props;
    return (
      <div
        className="animated-element"
        ref={el => this.getElementReference(el)}
        style={{ height: this.getHeight() }}
      >
        {this.elementShouldBeDisplayed() && children}
      </div>
    );
  }
}
